import { Component, Prop, Vue } from 'vue-property-decorator';
import { surveySpecsWithTicketGroupId } from '@/helpers/SurveyHelpers';
import { reportFormValidity } from '@/helpers/Validation';
import EventDetailErrorMessages from '@/components/events/EventDetailErrorMessages.vue';
import FormValidationGuard from '@/components/forms/FormValidationGuard.vue';
import Survey2 from '@/components/forms/Survey2.vue';
import TicketTypeRadioItem from '@/components/forms/TicketTypeRadioItem.vue';
import { reserveSubmitHandler } from '@/state/Reserve';
import MobileFooterPortal from '../cart/MobileFooterPortal.vue';
import ReserveMobileFooter from '../cart/ReserveMobileFooter.vue';
/**
 * A selector for special events where items are reserved one at a time.
 *
 * E.g. Donations, gift cards, memberships.
 *
 * This is an alternative to <ReserveDateFirst> and <ReserveQuantityFirst>.
 */
@Component({
    name: 'AddOneToCart',
    components: {
        FormValidationGuard,
        TicketTypeRadioItem,
        Survey2,
        MobileFooterPortal,
        ReserveMobileFooter,
        EventDetailErrorMessages,
    },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    event;
    @Prop({ required: true })
    category;
    @Prop()
    contexts;
    selectedType = null;
    apiError = null;
    submitting = false;
    surveyAnswers = {};
    formId = 'add-one-to-cart-form';
    get buttonLabel() {
        const language = this.$t('reserve.buttonLabel');
        return language[this.category] || language.default;
    }
    mounted() {
        const select = this.$route.query.select;
        if (select) {
            this.selectedType = {
                id: select,
            };
        }
        else if (this.event.ticketGroups.length === 1 && this.event.ticketGroups[0].types.length === 1) {
            this.selectedType = {
                id: this.event.ticketGroups[0].types[0].id,
            };
        }
    }
    onSubmit() {
        this.submit();
    }
    get validationMessage() {
        return this.contexts.has('handler:donation')
            ? 'Please select a donation to continue.'
            : 'Please select a gift card to continue.';
    }
    async submit(codes) {
        return this.validate()
            .then(() => {
            this.submitting = true;
            const submitOptions = {
                ticketsPayload: [this.reservation],
                surveyAnswers: this.surveyAnswers,
                selectedGroups: this.selectedGroups,
                emitCallback: this.$emit.bind(this),
                codes: codes,
            };
            return reserveSubmitHandler(submitOptions);
        })
            .catch((error) => {
            this.apiError = error;
        })
            .finally(() => {
            this.submitting = false;
        });
    }
    validate() {
        return reportFormValidity(this.$refs.form);
    }
    get reservation() {
        const type = this.selectedType;
        return {
            ticket_type_id: type.id,
            // Use `undefined` so the property is omitted when serializing to JSON.
            face_value: type.amount || undefined,
            // TODO Document this oddity better.
            admit_name: '',
            admit_email: '',
        };
    }
    get selectedGroups() {
        return this.event.ticketGroups.filter((group) => {
            return group.types.some((type) => this.selectedType?.id === type.id);
        });
    }
    get surveySpecs() {
        return surveySpecsWithTicketGroupId(this.selectedGroups);
    }
}
